module.exports = __webpack_public_path__ + "media/images/hang-up-small-da85bd77f82093faf4568d8da527bdb2.png";